import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 12px;
    align-items: center;
    margin-bottom: 24px;
    padding: 24px 16px 0;
    text-transform: capitalize;

    ${mediaQueries.laptop} {
        padding: 0;
    }
`;

export const Link = styled(RouterLink)`
    display: none;

    ${mediaQueries.laptop} {
        display: block;
        border-radius: 100%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme }) => theme['surface-default']};
    }
`;
